import React, { useEffect, useState } from "react";
import { db } from "../../firebase";
import {
  collection,
  getDocs,
  addDoc,
  doc,
  deleteDoc,
  updateDoc,
} from "firebase/firestore";
import Swal from "sweetalert2";
import axios from "axios";

export default function ManageInformasiGuru() {
  const [guru, setGuru] = useState([]);
  const [loading, setLoading] = useState(false);
  const [preview, setPreview] = useState(null);

  // ⛔ tetap disimpan sesuai permintaan (tidak dihapus)
  const [form, setForm] = useState({
    nama: "",
    jabatan: "",
    status: "",
    jenisKelamin: "",
    ttl: "",
    agama: "",
    nik: "",
    nip: "",
    nuptk: "",
    alamat: "",
    profilSingkat: "",
    pendidikan: "",
    pekerjaan: "",
    aktifMulai: "",
    fotoFile: null,
  });

  const ref = collection(db, "guruInfo");

  const fetchGuru = async () => {
    const snap = await getDocs(ref);
    const data = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
    setGuru(data);
  };

  useEffect(() => {
    fetchGuru();
  }, []);

  // ================= CLOUDINARY =================
  const uploadToCloudinary = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append(
      "upload_preset",
      process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET
    );

    const res = await axios.post(
      `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUDINARY_CLOUD_NAME}/image/upload`,
      formData
    );

    return res.data.secure_url;
  };

  // ================= TAMBAH GURU (SWEETALERT) =================
  const handleAddGuru = async () => {
    const { value } = await Swal.fire({
      title: "Tambah Data Guru Lengkap",
      width: "700px",
      html: buildFormHtml({}),
      showCancelButton: true,
      confirmButtonText: "Simpan",
      cancelButtonText: "Batal",
      preConfirm: () => collectFormValues(true),
    });

    if (!value) return;

    try {
      Swal.fire({
        title: "Menyimpan...",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      const fotoUrl = await uploadToCloudinary(value.fotoFile);
      const { fotoFile, ...payload } = value;

      await addDoc(ref, { ...payload, fotoUrl });

      Swal.fire("Berhasil!", "Guru berhasil ditambahkan", "success");
      fetchGuru();
    } catch (err) {
      console.error(err);
      Swal.fire("Error!", "Gagal menambahkan guru", "error");
    }
  };

  // ================= EDIT GURU =================
  const handleEdit = async (guruData) => {
    const { value } = await Swal.fire({
      title: "Edit Data Guru Lengkap",
      width: "700px",
      html: buildFormHtml(guruData),
      showCancelButton: true,
      confirmButtonText: "Simpan",
      cancelButtonText: "Batal",
      preConfirm: () => collectFormValues(false),
    });

    if (!value) return;

    try {
      Swal.fire({
        title: "Menyimpan perubahan...",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      let fotoUrl = guruData.fotoUrl;
      if (value.fotoFile) {
        fotoUrl = await uploadToCloudinary(value.fotoFile);
      }

      const { fotoFile, ...payload } = value;
      await updateDoc(doc(db, "guruInfo", guruData.id), {
        ...payload,
        fotoUrl,
      });

      Swal.fire("Berhasil!", "Data guru berhasil diperbarui", "success");
      fetchGuru();
    } catch (err) {
      console.error(err);
      Swal.fire("Error!", "Gagal memperbarui data", "error");
    }
  };

  // ================= DELETE =================
  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Yakin hapus data ini?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ya, hapus",
      cancelButtonText: "Batal",
    });

    if (!confirm.isConfirmed) return;

    await deleteDoc(doc(db, "guruInfo", id));
    Swal.fire("Terhapus!", "Data guru berhasil dihapus", "success");
    fetchGuru();
  };

  // ================= RENDER =================
  return (
    <div className="container mt-5">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>Kelola Informasi Guru & Staf</h2>
        <button className="btn btn-primary" onClick={handleAddGuru}>
          + Tambah Informasi Guru
        </button>
      </div>

      <div className="d-flex flex-wrap gap-3">
        {guru.map((g) => (
          <div key={g.id} className="card shadow-sm" style={{ width: 180 }}>
            <img
              src={g.fotoUrl}
              alt={g.nama}
              className="card-img-top"
              style={{ height: 250, objectFit: "cover" }}
            />
            <div className="card-body text-center p-2">
              <p className="fw-bold mb-0">{g.nama}</p>
              <small className="text-muted">{g.jabatan}</small>
              <div className="d-flex justify-content-center gap-1 mt-2">
                <a href={`/guru/${g.id}`} className="btn btn-info btn-sm">
                  Detail
                </a>
                <button
                  className="btn btn-warning btn-sm"
                  onClick={() => handleEdit(g)}
                >
                  Edit
                </button>
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => handleDelete(g.id)}
                >
                  Hapus
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

/* ===================== HELPER ===================== */

const buildFormHtml = (d) => `
<style>
.swal2-input,.swal2-textarea,.swal2-file{width:100%!important;margin:6px 0 12px}
label{font-weight:600;margin-top:8px;display:block}
</style>
<div style="max-height:65vh;overflow:auto;text-align:left">
${input("Nama","nama",d.nama)}
${input("Jabatan","jabatan",d.jabatan)}
${input("Status","status",d.status)}
${input("Jenis Kelamin","jenisKelamin",d.jenisKelamin)}
${input("T.T.L","ttl",d.ttl)}
${input("Agama","agama",d.agama)}
${input("NIK","nik",d.nik)}
${input("NIP","nip",d.nip)}
${input("NUPTK","nuptk",d.nuptk)}
${input("Alamat","alamat",d.alamat)}
<label>Profil Singkat</label>
<textarea id="profilSingkat" class="swal2-textarea">${d.profilSingkat || ""}</textarea>
${input("Pendidikan","pendidikan",d.pendidikan)}
${input("Pekerjaan","pekerjaan",d.pekerjaan)}
<label>Aktif Mulai</label>
<input id="aktifMulai" type="date" class="swal2-input" value="${d.aktifMulai || ""}">
<label>Foto</label>
<input id="fotoFile" type="file" class="swal2-file">
</div>
`;

const input = (label, id, value = "") =>
  `<label>${label}</label><input id="${id}" class="swal2-input" value="${value || ""}">`;

const collectFormValues = (fotoWajib) => {
  const fotoFile = document.getElementById("fotoFile").files[0];
  if (fotoWajib && !fotoFile) {
    Swal.showValidationMessage("Foto wajib diupload");
    return false;
  }

  return {
    nama: v("nama"),
    jabatan: v("jabatan"),
    status: v("status"),
    jenisKelamin: v("jenisKelamin"),
    ttl: v("ttl"),
    agama: v("agama"),
    nik: v("nik"),
    nip: v("nip"),
    nuptk: v("nuptk"),
    alamat: v("alamat"),
    profilSingkat: v("profilSingkat"),
    pendidikan: v("pendidikan"),
    pekerjaan: v("pekerjaan"),
    aktifMulai: v("aktifMulai"),
    fotoFile,
  };
};

const v = (id) => document.getElementById(id)?.value || "";
